import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastViewportComponent } from '@sandbox-platform/shared-ui';

@Component({
  standalone: true,
  imports: [RouterModule, ToastViewportComponent],
  selector: 'app-root',
  template: '<router-outlet></router-outlet><shared-toast-viewport />',
})
export class AppComponent {
  title = 'expert-app';
}
